var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-context',{ref:"menu",on:{"close":_vm.close},scopedSlots:_vm._u([{key:"default",fn:function(child){return (child.data)?[_c('context-usuario',{attrs:{"usuario":child.data.id}})]:undefined}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }